import FantasticDuelsPage from '@pages/FantasticDuelsPage/FantasticDuelsPage.vue';

export const fantasticDuelsPage = {
    content: FantasticDuelsPage,
};
